import { ROLE_REVEAL_MAX_SECONDS } from '@bm/shared';
import { de } from '@/i18n/de';
import { useAppStore } from '@/lib/store';
import { wsClient } from '@/lib/wsClient';
import { useWakeLock } from '@/lib/wakeLock';
import { mafiaColleagueNames } from '@/lib/colleagues';
import { AppShell } from '@/components/AppShell';
import { Button } from '@/components/Button';
import { GameHeader } from '@/components/GameHeader';
import { RoleCard } from '@/components/RoleCard';
import { Timer } from '@/components/Timer';

export function RoleRevealScreen() {
  const view = useAppStore((s) => s.view);
  useWakeLock(true);
  if (!view) return null;

  const acknowledgedCount = view.players.filter((player) => player.hasAcknowledgedRole).length;
  const waitingTotal = view.players.filter((player) => player.connected).length;

  return (
    // Der Header war hier lange weg. Ausgerechnet in dieser Phase stellt sich
    // aber die Frage „und was mache ich jetzt?" — die Regeln müssen erreichbar
    // sein, gerade für den, der zum ersten Mal mitspielt.
    <AppShell header={<GameHeader view={view} />}>
      <div className="flex h-full flex-col items-center justify-center gap-6">
        <RoleCard role={view.self.role} colleagueNames={mafiaColleagueNames(view)} />

        <div className="flex flex-col items-center gap-3">
          {view.self.hasAcknowledgedRole ? (
            <p className="text-sm text-fg-muted">
              {de.roleReveal.waitingFor(acknowledgedCount, waitingTotal)}
            </p>
          ) : (
            <Button onClick={() => wsClient.send({ type: 'role:acknowledge' })}>
              {de.roleReveal.continue}
            </Button>
          )}

          {/* Die Phase endet nach spätestens 90 Sekunden von selbst. Ohne
              sichtbare Uhr kommt der Sprung in die Diskussion unangekündigt —
              ausgerechnet für den, der seine Rolle noch liest. */}
          <Timer
            endsAt={view.phaseEndsAt}
            totalSeconds={ROLE_REVEAL_MAX_SECONDS}
            size={72}
            label={de.common.timerRoleReveal}
          />
        </div>
      </div>
    </AppShell>
  );
}
